<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
    <!-- Header -->
    <div class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent">
        <div class="flex-1 min-w-0">
            <div class="flex">
                <a class="inline-flex items-center -ml-1.5 text-secondary font-medium" [routerLink]="'/profile-dashboard'">
                    <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
                    <span class="ml-1">Back</span>
                </a>
            </div>
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    Attendance
                </h2>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card" cdkScrollable>
        <!-- Permission denied message -->
        <div *ngIf="!canViewAttendance" class="w-full py-8 text-center">
            <h2 class="text-2xl font-bold text-gray-600 mb-2">Access Denied</h2>
            <p class="text-gray-500">You don't have permission to view attendance.</p>
        </div>

        <!-- Attendance content -->
        <div *ngIf="canViewAttendance">
            <!-- Filter -->
            <div class="mb-6">
                <mat-form-field appearance="outline" class="w-full sm:w-64">
                    <mat-label>Filter by Program</mat-label>
                    <mat-select (selectionChange)="onProgramChange($event.value)">
                        <mat-option [value]="null">All Programs</mat-option>
                        <mat-option *ngFor="let program of programs" [value]="program.Id">
                            {{ program.Name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Table -->
            <table mat-table [dataSource]="filteredClassSchedules" class="mat-elevation-z8 w-full" *ngIf="filteredClassSchedules.length > 0">
                <!-- Program Column -->
                <ng-container matColumnDef="program">
                    <th mat-header-cell *matHeaderCellDef>Class Schedules</th>
                    <td mat-cell *matCellDef="let schedule" class="clickable" (click)="onViewAttendance(schedule)">
                        {{ schedule.Name }}
                    </td>
                </ng-container>

                <!-- Attendance Status Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="text-center">Attendance Status</th>
                    <td mat-cell *matCellDef="let schedule" class="text-center">
                        <span *ngIf="getAttendanceStatus(schedule.Id)" class="flex justify-center items-center">
                            <mat-icon 
                                [matTooltip]="'Attendance is marked'"
                                matTooltipPosition="above"
                                class="text-[#7cbd4a]"
                            >check_circle</mat-icon>
                        </span>
                        <span *ngIf="!getAttendanceStatus(schedule.Id)" class="flex justify-center items-center">
                            <mat-icon 
                                [matTooltip]="'Attendance is not marked'"
                                matTooltipPosition="above"
                                class="text-red-500"
                            >cancel</mat-icon>
                        </span>
                    </td>
                </ng-container>

                <!-- Day Column -->
                <ng-container matColumnDef="day">
                    <th mat-header-cell *matHeaderCellDef>Day</th>
                    <td mat-cell *matCellDef="let schedule">
                        {{ schedule.Program_day__c}}
                    </td>
                </ng-container>

                <!-- Date Column -->
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>Date</th>
                    <td mat-cell *matCellDef="let schedule">
                        {{ schedule.Date__c | date:'mediumDate' }}
                    </td>
                </ng-container>

                <!-- Time Column -->
                <ng-container matColumnDef="time">
                    <th mat-header-cell *matHeaderCellDef>Time</th>
                    <td mat-cell *matCellDef="let schedule">
                        {{ formatTime(schedule.Start_Time__c) }} - {{ formatTime(schedule.End_Time__c) }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['program', 'day', 'date', 'time', 'status']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['program', 'day', 'date', 'time', 'status']"></tr>
            </table>

            <div *ngIf="filteredClassSchedules.length === 0" class="w-full py-8 text-center font-bold text-lg text-gray-600">
                No class schedules found.
            </div>
        </div>
    </div>
</div>